import { combineReducers } from 'redux';

import { IProperty } from '../../../../data/entities/property';
import { IEntityActions } from '../../../../data/store';
import { Actions as UserActions } from '../actions';

const propertySearchResults = (state: IProperty[] = [], action: IEntityActions | UserActions = {} as any) => {
	switch (action.type) {
		case 'PROPERTY_SEARCH_RECEIVE':
			return action.payload.properties;
		case 'PROPERTY_SEARCH_FAILURE':
		case 'ADMIN_CLEAR_PROPERTY_RESULTS':
			return [];
		default:
			return state;
	}
};

export default combineReducers({
	propertySearchResults
});
